import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import ReactImageMagnify from 'react-image-magnify';

export default class Image extends Component {
  state = {
    width: null,
    height: null,
  };

  renderImage = () => {
    const { image, alt, zoom } = this.props;
    const { width, height } = this.state;
    return zoom ? (
      <ReactImageMagnify
        ref="img"
        style={{ width: '100%', height: '100%' }}
        {...{
          enlargedImagePosition: 'over',
          isHintEnabled: true,
          smallImage: {
            alt: alt,
            isFluidWidth: true,
            onLoad: e =>
              this.setState({ width: e.target.width, height: e.target.height }),
            src: image,
            onError: e =>
              (this.refs['img']['smallImageEl'].src = `/img/noimage.jpeg`),
          },
          largeImage: {
            src: image,
            width: width * 4,
            height: height * 4,
          },
        }}
      />
    ) : (
      <img
        ref="img"
        alt={alt}
        src={image}
        style={{ maxHeight: '700px' }}
        {...this.props}
        onError={e => (this.refs['img'].src = '/img/noimage.jpeg')}
      />
    );
  };
  render() {
    const { noLazy } = this.props;
    return noLazy ? (
      this.renderImage()
    ) : (
      <LazyLoad throttle={200} height={300} once>
        {this.renderImage()}
      </LazyLoad>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/index.js